import { graphql } from "api/cms-website/generated";

export const LeadFormFragment = graphql(/* GraphQL */ `
    fragment LeadFormFragment on ComponentComponentsLeadForm {
        id
        leadFormTitle: title
        leadFormImage: image {
            ...ResponsiveImageFragment
        }
        showTreatmentTypeSelector
        defaultTreatmentType
        showPromoCodeCTA
        showPatientCategorySelector
        defaultPatientCategory
    }
`);
